<template>
  <div class="content_box">
    <div class="content_head">
      <div style="display: flex; align-items: center" @click="showRrchargeInfo">
        <div class="user_avatar">
          <img src="../assets/user3.png" class="user3_img" />
        </div>
        <div class="userName">智云电力山东有限公司（8008202852）</div>
      </div>
      <!-- 弹窗 -->
      <div class="modal" v-if="show">
        <div class="consName">智云电力山东有限公司（8008202852）</div>
        <div class="consBalance">
          <div>当期电费：892.75元</div>
          <div>可用余额：-490.62元</div>
        </div>
        <div class="btn_box">
          <div style="display:flex;align-items:center">
            <img src="@/assets/add.png" class="add_img" />
            <span>添加账号</span>
          </div>
          <div style="display:flex;align-items:center">
            <img src="@/assets/find.png" class="find_img" />
            <span>查询户号</span>
          </div>
        </div>
      </div>
      <img src="../assets/xiala.png" alt />
    </div>
    <div class="info_box" style="padding-bottom: 30px">
      <div class="info_item">
        <div class="indo_key">交费地区</div>
        <div class="info_value">山东省</div>
      </div>
      <div class="info_item">
        <div class="indo_key">客户编号</div>
        <div class="info_value">0866277888</div>
      </div>
      <div class="info_item">
        <div class="indo_key">请输入验证码</div>
        <input type="text" placeholder="请输入验证码" v-model="value" />
      </div>
      <div class="btn_box">
        <van-button @click="sureRearch" style="height: 35px" type="primary" block>立即充值</van-button>
      </div>
    </div>
    <div class="line"></div>
    <div class="history_box">
      <div class="history_head">
        <div class="shu"></div>
        <div class="history_title">历史交费客户</div>
      </div>
      <div class="history_content">
        <div class="history_item">
          <img class="recharge_img" src="../assets/recharge.png" alt />
          <div style="margin-left: 10px">
            <div class="history_username">
              <span>0295291712</span>|
              <span>智云电力山东有限公司</span>
            </div>
            <div class="address">天正胡秉钧约个</div>
          </div>
          <div class="click_btn">立即交费</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button } from "vant";
Vue.use(Button);
export default {
  created() {
    if (this.$route.query.consId) {
      this.consId = this.$route.query.consId;
    }
  },
  data() {
    return {
      value: "",
      show: true,
      consId: ""
    };
  },
  methods: {
    sureRearch() {
      this.$router.push({
        path: `/tcmr/wxRecharge?consId=${this.consId}`
      });
    },
    showRrchargeInfo() {
      this.show = false;
    }
  }
};
</script>
<style  scoped>
.btn_box {
  height: 0.75rem;
  color: #50c7a1;
  font-size: 0.24rem;
  display: flex;
  justify-content: space-around;
}
.add_img {
  width: 0.25rem;
  height: 0.25rem;
  margin-right: 0.05rem;
  margin-bottom: 0.02rem;
}

.find_img {
  width: 0.3rem;
  margin-right: 0.05rem;
  margin-bottom: 0.02rem;
}

.consName {
  height: 0.75rem;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.75rem;
}
.consBalance {
  display: flex;
  height: 0.4rem;
  font-size: 0.24rem;
  line-height: 0.4rem;
  justify-content: space-around;
  border-bottom: 0.01rem solid #ddd;
}
.modal {
  left: 0;
  top: 0.8rem;
  width: 100%;
  float: left;
  z-index: 1000;
  position: absolute;
  min-width: 160 px;
  padding: 5 px 0;
  margin: 2 px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border: 1 px solid #ccc;
  border: 1 px solid rgba(0, 0, 0, 0.15);
  border-radius: 4 px;
  -webkit-box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
  box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
}
.click_btn {
  font-size: 14px;
  padding: 3px 5px;
  color: #50c7a1;
  margin-left: 10px;
  border-radius: 10px;
  border: 1px solid #50c7a1;
}
.history_item {
  display: flex;
  align-items: center;
  padding: 10px 0 10px 20px;
  border: 1px solid #f4f4f4;
}
.address {
  font-size: 12px;
  color: #a7a6a5;
  text-align: left;
  margin-top: 5px;
}

.history_username {
  font-size: 14px;
}
.recharge_img {
  width: 24px;
  height: 24px;
}
.history_title {
  font-size: 16px;
  margin-left: 10px;
}
.history_head {
  display: flex;
  align-items: center;
  padding: 10px 0 10px 20px;
  border-bottom: 2px solid #50c7a1;
}
.shu {
  width: 2px;
  height: 20px;
  background: #50c7a1;
}
.line {
  height: 10px;
  background: #f6f7f9;
}
.userName {
  margin-left: 10px;
  font-size: 14px;
}
.user3_img {
  left: 0;
  width: 25px;
  height: 25px;
  position: absolute;
}
.user_avatar {
  width: 25px;
  height: 25px;
  position: relative;
  background: #d6eae6;
}
.content_head {
  display: flex;
  align-items: center;
  background: #f3f4f1;
  padding: 10px 20px 10px 20px;
  justify-content: space-between;
}
.info_item {
  display: flex;
  margin: 0px 20px;
  padding: 10px 0;
  align-items: center;
  border-bottom: 1px solid #efefef;
}
.indo_key {
  width: 100px;
  font-size: 14px;
  color: #686e71;
  text-align: right;
}
.info_value {
  margin-left: 20px;
  font-size: 14px;
  margin-left: 10px;
}
input {
  border: 0;
  font-size: 14px;
  padding-left: 10px;
}
.btn_box {
  padding: 0 20px;
  margin-top: 30px;
}
</style>